<template>
	<div>
		<div class="inputList" v-if="isBasic">
			<labelInput :outInput="newform.name" :spanRequired="true" normalPlace="请输入姓名" @inputChange="labelInput($event,'real_name')"
				spanTitle="姓名" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.id_card" :spanRequired="true" normalPlace="请输入身份证号码" :isIdcard="true" specilType='limit' :maxLimit="18"
				@inputChange="labelInput($event,'id_card')" spanTitle="身份证号码" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<normalPicker :outInput="newform.birth_date" :spanRequired="true" pelaceHolder="请输入出生年月" spanTitle="出生年月" :spanWidth="spanWidth"
				@selectDate="labelInput($event,'birth_date')" componentWidth="520px">
			</normalPicker>
			<normalSelect :outInput="newform.education" :spanRequired="true" @selectCode="labelInput($event,'education')" :spanWidth="spanWidth"
				:dataList="dataList" componentWidth="520px" spanTitle="学历">
			</normalSelect>
			<normalPicker :outInput="newform.join_work_time" :spanRequired="true" pickerType="month" pelaceHolder="请输入参加工作时间" spanTitle="参加工作时间"
				:spanWidth="spanWidth" @selectDate="labelInput($event,'join_work_time')" componentWidth="520px">
			</normalPicker>

			<normalSelect :outInput="newform.title" :spanRequired="true" @selectCode="labelInput($event,'title')" :spanWidth="spanWidth"
						  :dataList="dataList4" componentWidth="520px" spanTitle="职称">
			</normalSelect>


			<normalSelect :outInput="newform.major" :spanRequired="true" @selectCode="labelInput($event,'major')" :spanWidth="spanWidth"
						  :dataList="dataList3" componentWidth="520px" spanTitle="建造师专业">
			</normalSelect>


			<normalSelect :outInput="newform.level" :spanRequired="true" @selectCode="labelInput($event,'level')" :spanWidth="spanWidth"
						  :dataList="dataList2" componentWidth="520px" spanTitle="建造师等级">
			</normalSelect>


			<div style="display: flex;">
				<labelInput :outInput="req_num" :spanRequired="true" @inputChange="labelInput($event,'req_num')" specilType='limit'
					:maxLimit="1" spanTitle="注册编号" normalPlace="京" :spanWidth="spanWidth" componentWidth="270px">
				</labelInput>
				<div class="specialView">
					<p style="color:#DBDBDB;">—</p>
					<input v-model.lazy="req_num_code" style="margin-left: 10px;" type="number"
						oninput="if(value.length>16) value = value.slice(0,16)" placeholder="如:111050700001" />
				</div>
			</div>
			<labelInput :outInput="newform.post" :spanRequired="true" normalPlace="请输入获奖工程所从事职务" @inputChange="labelInput($event,'present_post')"
				spanTitle="获奖工程所从事职务" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.tellphone" :spanRequired="true" normalPlace="请输入本人联系电话" @inputChange="labelInput($event,'cellphone')"
				spanTitle="本人联系电话" :isPhone="true" specilType='number' :maxLimit="11" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.major" :spanRequired="true" normalPlace="请输入单位主管部门" @inputChange="labelInput($event,'head_dep')"
				spanTitle="单位主管部门" :spanWidth="spanWidth" componentWidth="520px"></labelInput>
			<div class="" style="width: 520px;">

			</div>
			<labelInput :outInput="newform.enp_contacts" :spanRequired="true" normalPlace="请输入单位联系人" @inputChange="labelInput($event,'enp_contact')"
				spanTitle="单位联系人" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.enp_contacts_phone" :spanRequired="true" normalPlace="请输入联系电话" @inputChange="labelInput($event,'enp_contact_phone')"
				spanTitle="联系电话" :isPhone="true" specilType='number' :maxLimit="11" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
		</div>
		<!-- 获奖信息 -->
		<div class="awardInfo" v-else>
			<p class="view_head titleLeft">质量获奖情况（必填）</p>
			<div class="inputList">
				<labelInput :outInput="project_name1" :spanRequired="true" spanTitle="工程名称" normalPlace="请输入工程名称"
					@inputChange="labelInput2($event,'project_name','0')" :spanWidth="spanWidth"
					componentWidth="90%">
				</labelInput>
				<labelInput :outInput="award_name1" :spanRequired="true" normalPlace="请输入获奖名称"
					@inputChange="labelInput2($event,'award_name','0')" spanTitle="获奖名称" :spanWidth="spanWidth"
					componentWidth="520px">
				</labelInput>

				<normalPicker :outInput="award_time1" :spanRequired="true" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
					@selectDate="labelInput2($event,'award_time','0')" componentWidth="520px">
				</normalPicker>
				<div class="dash_bottom">
				</div>
			</div>

			<div class="view_head_special" style="width: 100%;height: 50px;">
				<p style="color: red">以下三项，至少填写一项</p>
			</div>
			<p class="view_head titleLeft">安全文明情况（近三年主持或参与的工程获北京市级或省部级“建筑业绿色施工示范工程”，获北京市级或省部级“文明安全工地”）</p>
			<div class="inputList">
				<labelInput :outInput="project_name2" normalPlace="请输入工程名称" 
				@inputChange="labelInput2($event,'project_name','1')" spanTitle="工程名称"
					:spanWidth="spanWidth" componentWidth="90%">
				</labelInput>
				<labelInput :outInput="award_name2" normalPlace="请输入获奖名称" 
				@inputChange="labelInput2($event,'award_name','1')" spanTitle="获奖名称"
					:spanWidth="spanWidth" componentWidth="520px">
				</labelInput>

				<normalPicker :outInput="award_time2" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
					@selectDate="labelInput2($event,'award_time','1')" componentWidth="520px">
				</normalPicker>
				<div class="dash_bottom">

				</div>
			</div>
			<!-- 优秀建造师新增 -->
			<p class="view_head titleLeft">行业标准、工法、专利情况（近三年参与制定有关建筑施工的省部级地方标准、行业标准证书、专利;参与制定省部级工法、国家工法、专利证明资料。）</p>
			<div class="inputList">
				<labelInput :outInput="award_name3" normalPlace="请输入获奖名称" 
				@inputChange="labelInput2($event,'award_name','2')" spanTitle="获奖名称"
					:spanWidth="spanWidth" componentWidth="520px">
				</labelInput>

				<normalPicker :outInput="award_time3" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
					@selectDate="labelInput2($event,'award_time','2')" componentWidth="520px">
				</normalPicker>
				<div class="dash_bottom">

				</div>
			</div>

			<p class="view_head titleLeft">科技示范、项目管理成果情况、（近三年主持或参与的工程获省部级（含）以上科技进步奖、科技示范工程、科技成果鉴定、项目管理成果奖证明资料）</p>
			<div class="inputList">
				<labelInput :outInput="award_name4" normalPlace="请输入获奖名称" 
				@inputChange="labelInput2($event,'award_name','3')" spanTitle="获奖名称"
					:spanWidth="spanWidth" componentWidth="520px">
				</labelInput>

				<normalPicker :outInput="award_time4" pelaceHolder="请输入获奖时间" spanTitle="获奖时间" :spanWidth="spanWidth"
					@selectDate="labelInput2($event,'award_time','3')" componentWidth="520px">
				</normalPicker>
				<div class="dash_bottom">

				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import labelInput from '../../../components/table/labelInput.vue'
	import normalPicker from '../../../components/table/normalPicker.vue'
	import normalSelect from '../../../components/table/normalSelect.vue'
	export default {
		data() {
			return {
				project_name1: '',
				award_name1: '',
				award_time1: '',
				project_name2: '',
				award_name2: '',
				award_time2: '',
				award_name3: '',
				award_time3: '',
				award_name4: '',
				award_time4: '',
				
				spanWidth: '180px',
				newform:{},
				form: {
					real_name: '',
					id_card: '',
					birth_date: '',
					project_code: '',
					education: '',
					join_work_time: '',
					title: '',
					major: '',
					level: '',
					req_num: '',
					cellphone: '',
					head_dep: '',
					enp_contact: '',
					enp_contact_phone: '',
					present_post: '',
				},
				req_num:'',
				req_num_code: '',
				// 学历下拉框
				dataList: [
					[{
							name: '大专',
							code: '大专'
						}, {
							name: '本科',
							code: '本科'
						}, {
							name: '硕士',
							code: '硕士'
						},
						{
							name: '博士',
							code: '博士'
						}
					]
				],

				dataList2: [
					[{
						name: '一级',
						code: '一级'
					}, {
						name: '二级',
						code: '二级'
					}
					]
				],

				dataList4: [
					[
							{
						name: '正高级',
						code: '正高级'
					}, {
						name: '副高级',
						code: '副高级'
						},{
						name: '中级',
						code: '中级'
						},{
						name: '助理级',
						code: '助理级'
						},
					]
				],

				dataList3: [
					[{
						name: '建筑工程',
						code: '建筑工程'
					},
					{
						name: '市政公用工程',
						code: '市政公用工程',
					},{
						name: '机电工程',
						code: '机电工程',
					},{
						name: '公路工程',
						code: '公路工程',
					},{
						name: '水利水电工程',
						code: '水利水电工程',
					},{
						name: '铁路工程',
						code: '铁路工程',
					},{
						name: '民航机场工程',
						code: '民航机场工程',
					},{
						name: '港口与航道工程',
						code: '港口与航道工程',
					},{
						name: '通信与广电工程',
						code: '通信与广电工程',
					},{
						name: '矿业工程',
						code: '矿业工程',
					},


					]
				],


			}
		},
		components: {
			labelInput,
			normalPicker,
			normalSelect
		},
		watch: {
			req_num_code(newvalue, oldvalue) {
				this.$emit('req_num_code', newvalue)
			},
			basicMsg(newvalue) {
				this.newform = {
					...newvalue
				}
				this.req_num = newvalue.req_number.split('').slice(0, 1)[0]
				this.req_num_code = newvalue.req_number.split('').slice(1).join('')
			},
			awardMsg(newvalue) {
				this.project_name1 = newvalue[0].project_name
				this.award_name1 = newvalue[0].award_name
				this.award_time1 = newvalue[0].award_time
				this.project_name2 = newvalue[1].project_name
				this.award_name2 = newvalue[1].award_name
				this.award_time2 = newvalue[1].award_time,
				this.award_name3 = newvalue[2].award_name
				this.award_time3 = newvalue[2].award_time
				this.award_name4 = newvalue[3].award_name
				this.award_time4 = newvalue[3].award_time
			}
		},
		props: {
			// 切换基本信息和获奖信息
			isBasic: {
				type: Boolean,
				default: true
			},
			basicMsg: {
				type: Object,
				default: () => {
					return {}
				}
			},
			awardMsg: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		created() {
			if (this.isBasic) {
				this.$emit('basicInfo', this.form)
			}
		},
		methods: {
			labelInput(e, name) {
				this.form[name] = e
				this.$emit('basicInfo', this.form)
			},
			labelInput2(e, name, id) {
				const params = [id, name, e]
				this.$emit('awardInfo', params)
			}
		}
	}
</script>

<style scoped>
	.midflex {
		width: 100%;
		text-align: center;
		margin-bottom: 20px;
	}

	.inputList {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	.view_head {
		font-size: 18px;
		font-weight: 600;
		margin-top: 20px;
	}

	.titleLeft {
		margin-left: 50px;
	}

	.awardInfo {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	
	@media screen and (max-width: 500px) {
		.specialView {
			width: 240px;
			display: flex;
			align-items: center;
		}
	}
	@media screen and (min-width: 500px) and (max-width: 1500px) {
		.specialView {
			width: 240px;
			display: flex;
			align-items: center;
		}
	}
	@media screen and (min-width: 1500px) {
		.specialView {
			width: 780px;
			display: flex;
			align-items: center;
		}
	}
	.specialView input {
		margin-left: 20px;
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		letter-spacing: 1px;
		border-bottom: 1px solid #DBDBDB;
	}

	.specialView input::placeholder {
		color: #B5B5B5;
	}

	.view_head_special {
		font-size: 16px;
		font-weight: 500;
		margin-top: 20px;
		color: #FF9900;
	}
</style>
